'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

var getCVReviews = function (jobId, accessToken, baseMsUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var apiUrl, res, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiUrl = "".concat(baseMsUrl, "/api-gateway/v1.0/ai-resume-review?jobId=").concat(jobId);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch(apiUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    })];
            case 2:
                res = _a.sent();
                if (!(res.status === 200)) return [3 /*break*/, 4];
                return [4 /*yield*/, res.json()];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 4: return [2 /*return*/, []];
            case 5:
                e_1 = _a.sent();
                console.log('error', e_1);
                return [2 /*return*/, []];
            case 6: return [2 /*return*/];
        }
    });
}); };
function getAITrial(_a) {
    var _b;
    var baseMsUrl = _a.baseMsUrl, accessToken = _a.accessToken;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseData, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/api-gateway/v1.0/buy-package/count-trial-car-package"), {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseData = _c.sent();
                    if (responseData.data) {
                        return [2 /*return*/, {
                                trial: (_b = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _b === void 0 ? void 0 : _b.trial
                            }];
                    }
                    return [2 /*return*/, null];
                case 3:
                    error_1 = _c.sent();
                    console.error('error', error_1);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { getAITrial, getCVReviews };
//# sourceMappingURL=services.js.map
